import { jsxs as f, jsx as t } from "react/jsx-runtime";
import i from "react";
const d = i.memo(({
  width: e = 12,
  color: l = "#0367db",
  height: o = 12
}) => /* @__PURE__ */ f("svg", { fill: "none", height: o, viewBox: "0 0 12 12", width: e, children: [
  /* @__PURE__ */ t("path", { d: "M5 0h2v12H5z", fill: l }),
  /* @__PURE__ */ t("path", { d: "M0 5h12v2H0z", fill: l })
] }));
export {
  d as default
};
//# sourceMappingURL=PlusIcon.es.js.map
